export const getDatasetButtonsWrapperInlineStyle = (
  datasetMinWidth: number,
  datasetLocked: boolean
) => {
  if (datasetMinWidth <= 0) return undefined;
  if (datasetLocked)
    return {
      minWidth: datasetMinWidth,
      width: datasetMinWidth,
      maxWidth: datasetMinWidth,
    };
  return { minWidth: datasetMinWidth };
};
